import { render, staticRenderFns } from "./AddSection.vue?vue&type=template&id=fc5696a2&scoped=true"
import script from "./AddSection.vue?vue&type=script&lang=js"
export * from "./AddSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc5696a2",
  null
  
)

export default component.exports